import { Navigate, createBrowserRouter } from 'react-router-dom';

import {
    DevicePasswordPage,
    DownloadKeysPage,
    ErrorPage,
    HomePage,
    LoginPage,
    Page404,
    ResetPage,
} from '@/pages';

import AuthRoutes from './AuthRoute';
import ProtectedRoute from './ProtectedRoute';
import { ROOT_PATH } from './router.types';

const router = createBrowserRouter([
    {
        path: '/',
        errorElement: <ErrorPage />,
        children: [
            {
                element: <ProtectedRoute />,
                children: [
                    {
                        index: true,
                        element: <HomePage />,
                    },
                    {
                        path: ROOT_PATH.devicePassword,
                        element: <DevicePasswordPage />,
                    },
                    {
                        path: ROOT_PATH.downloadKeys,
                        element: <DownloadKeysPage />,
                    },
                ],
            },
            {
                path: ROOT_PATH.auth,
                element: <AuthRoutes />,
                children: [
                    {
                        index: true,
                        element: <Navigate to={ROOT_PATH.login} replace />,
                    },
                    { path: 'login', element: <LoginPage /> },

                    { path: 'resetPassword', element: <ResetPage /> },
                ],
            },
            { path: '*', element: <Page404 /> },
        ],
    },
]);
export default router;
